// Don't use nested object in this file.
export default {
  DashboardView: "db-v",
  // List permissions of autocomplete async
  CountryShort: "*",
  ProvinceShort: "*",
  DistrictShort: "*",
  WardShort: "*",
  DeductionShort: "*",
  AllowanceShort: "*",
  EarningShort: "*",
  CompensationShort: "*",
  LeavePolicyShort: "*",
  WorkLevelShort: "*",
  DepartmentShort: "*",
  TitleShort: "*",
  BranchShort: "*",
  ContractTypeShort: "*",
  EmployeeShort: "empl:rbs",
  PayrollTemplateShort: "*",
  PayrollTemplatePicShort: "*",
  TimezoneShort: "*",
  WorkShiftShort: "*",
  LeaveTypeShort: "*",
  BankShort: "*",
  ApprovalWorkflowShort: "*",
  EthnicityShort: "*",
  RoleShort: "*",
  BenefitsInKindShort: "*",
  PayrollCycleShort: "*",
  MachineShort: "*",
  MachineGroupShort: "*",
  ProductShort: "*",
  ReasonStopMachineShort: "*",
  ProductivityTemplateShort: "*",
  ProductivityTemplateMeShort: "*",
  ProductivityWorkShiftShort: "*",

  // Payroll setting -> Leave policies
  PayrollSettingLeavePoliciesList: "tlp:rb",
  PayrollSettingLeavePoliciesDetail: "tlp:r",
  PayrollSettingLeavePoliciesCreate: "tlp:c",
  PayrollSettingLeavePoliciesEdit: "tlp:e",
  PayrollSettingLeavePoliciesDelete: "tlp:d",
  PayrollSettingLeavePoliciesImport: "tlp:im",
  PayrollSettingLeavePoliciesExport: "tlp:rb",
  // Payroll setting -> Holiday
  PayrollSettingHolidayList: "prhm:rb",
  PayrollSettingHolidayDetail: "prhm:r",
  PayrollSettingHolidayCreate: "prhm:c",
  PayrollSettingHolidayEdit: "prhm:e",
  PayrollSettingHolidayDelete: "prhm:d",
  PayrollSettingHolidayImport: "prhm:im",
  PayrollSettingHolidayExport: "prhm:rb",
  // Payroll setting -> Leave type
  PayrollSettingLeaveTypeList: "tlt:rb",
  PayrollSettingLeaveTypeDetail: "tlt:r",
  PayrollSettingLeaveTypeCreate: "tlt:c",
  PayrollSettingLeaveTypeEdit: "tlt:e",
  PayrollSettingLeaveTypeDelete: "tlt:d",
  PayrollSettingLeaveTypeImport: "tlt:im",
  PayrollSettingLeaveTypeExport: "tlt:rb",
  // Payroll setting -> allowance
  PayrollSettingAllowanceList: "pram:rb",
  PayrollSettingAllowanceDetail: "pram:r",
  PayrollSettingAllowanceCreate: "pram:c",
  PayrollSettingAllowanceEdit: "pram:e",
  PayrollSettingAllowanceDelete: "pram:d",
  PayrollSettingAllowanceImport: "*",
  PayrollSettingAllowanceExport: "pram:rb",
  // Payroll setting -> Work shift
  PayrollSettingWorkShiftList: "tws:rb",
  PayrollSettingWorkShiftDetail: "tws:r",
  PayrollSettingWorkShiftCreate: "tws:c",
  PayrollSettingWorkShiftEdit: "tws:e",
  PayrollSettingWorkShiftDelete: "tws:d",
  PayrollSettingWorkShiftImport: "*",
  PayrollSettingWorkShiftExport: "tws:rb",
  // Payroll setting -> Compensation package
  PayrollSettingCompensationPackageList: "tcpst:rb",
  PayrollSettingCompensationPackageDetail: "tcpst:r",
  PayrollSettingCompensationPackageCreate: "tcpst:c",
  PayrollSettingCompensationPackageEdit: "tcpst:e",
  PayrollSettingCompensationPackageDelete: "tcpst:d",
  PayrollSettingCompensationPackageImport: "tcpst:im",
  PayrollSettingCompensationPackageExport: "tcpst:rb",

  // Payroll setting -> Regional minimum wage
  PayrollSettingRegionalMinimumWageList: "*",
  PayrollSettingRegionalMinimumWageDetail: "*",
  PayrollSettingRegionalMinimumWageCreate: "SUPER_ADMIN",
  PayrollSettingRegionalMinimumWageEdit: "SUPER_ADMIN",
  PayrollSettingRegionalMinimumWageDelete: "SUPER_ADMIN",
  PayrollSettingRegionalMinimumWageImport: "*",
  PayrollSettingRegionalMinimumWageExport: "*",

  // Payroll setting -> PIT Rate
  PayrollSettingPITRateList: "*",
  PayrollSettingPITRateDetail: "*",
  PayrollSettingPITRateCreate: "SUPER_ADMIN",
  PayrollSettingPITRateEdit: "SUPER_ADMIN",
  PayrollSettingPITRateDelete: "SUPER_ADMIN",
  PayrollSettingPITRateImport: "*",
  PayrollSettingPITRateExport: "*",

  // Payroll setting -> Insurance
  PayrollSettingInsuranceList: "*",
  PayrollSettingInsuranceCreate: "*",
  PayrollSettingInsuranceEdit: "*",
  PayrollSettingInsuranceDelete: "*",
  PayrollSettingInsuranceImport: "*",
  PayrollSettingInsuranceExport: "*",

  // Payroll setting -> Payroll template
  PayrollSettingPayrollTemplateList: "prtm:rb",
  PayrollSettingPayrollTemplateDetail: "prtm:r",
  PayrollSettingPayrollTemplateCreate: "prtm:c",
  PayrollSettingPayrollTemplateEdit: "prtm:e",
  PayrollSettingPayrollTemplateDelete: "prtm:d",
  PayrollSettingPayrollTemplateImport: "prtm:im",
  PayrollSettingPayrollTemplateExport: "prtm:rb",
  PayrollSettingPayrollTemplateCreateField: "prtm:prfm:c",
  PayrollSettingPayrollTemplateCreateGroupField: "prtgfm:prtgfm:c",
  PayrollSettingPayrollTemplateUpdateBulkField: "prtm:prfm:eb",
  PayrollSettingPayrollTemplateUpdateBulkGroupField: "prtm:prfm:eb",
  PayrollSettingPayrollTemplatePrintTemplateCreate: "prtm:c",
  PayrollSettingPayrollTemplatePrintTemplateEdit: "prtm:e",
  PayrollSettingPayrollTemplatePrintTemplateDeteil: "prtm:r",
  PayrollSettingPayrollTemplatePrintTemplateDelete: "prtm:d",
  PayrollSettingPayrollTemplatePrintTemplateList: "prtm:rb",

  // Payroll setting -> Deduction
  PayrollSettingDeductionList: "prdm:rb",
  PayrollSettingDeductionListShort: "prdm:rbs",
  PayrollSettingDeductionCreate: "prdm:c",
  PayrollSettingDeductionDetail: "prdm:r",
  PayrollSettingDeductionEdit: "prdm:e",
  PayrollSettingDeductionDelete: "prdm:d",
  PayrollSettingDeductionImport: "prdm:im",
  PayrollSettingDeductionExport: "prdm:rb",

  // Payroll setting -> Earning
  PayrollSettingEarningList: "teg:rb",
  PayrollSettingEarningDetail: "teg:r",
  PayrollSettingEarningCreate: "teg:c",
  PayrollSettingEarningEdit: "teg:e",
  PayrollSettingEarningDelete: "teg:d",
  PayrollSettingEarningImport: "teg:im",
  PayrollSettingEarningExport: "teg:rb",

  // Payroll setting -> KPI Setting
  PayrollSettingKPISettingList: "prks:rb",
  PayrollSettingKPISettingDetail: "prks:r",
  PayrollSettingKPISettingCreate: "prks:c",
  PayrollSettingKPISettingEdit: "prks:e",
  PayrollSettingKPISettingDelete: "prks:d",
  PayrollSettingKPISettingImport: "prks:im",
  PayrollSettingKPISettingExport: "prks:rb",

  // KPI Individuals
  KpiIndividualsList: "tpkim:rb",
  KpiIndividualsRun: "tpkim:c",
  KpiIndividualsApprovalStatus: "tpkim:rb",
  KpiIndividualsRequestList: "tpkim:trm:rb",
  KpiIndividualsRequestDetail: "tpkim:trm:r",
  KpiIndividualsRequestCreate: "tpkim:trm:c",
  KpiIndividualsRequestUpdate: "tpkim:trm:e",
  KpiIndividualsRequestApprove: "tpkim:trm:ap",
  KpiIndividualsUpdateBonus: "tpkim:e",
  KpiIndividualsPrintSampleList: "tpkim:rb",
  KpiIndividualsPrintSampleDetail: "tpkim:r",
  KpiIndividualsPrintSampleCreate: "tpkim:c",
  KpiIndividualsPrintSampleEdit: "tpkim:e",
  KpiIndividualsPrintSampleDelete: "tpkim:d",

  // KPI Departments
  KpiDepartmentsList: "tpkdm:rb",
  KpiDepartmentsRun: "tpkdm:c",
  KpiDepartmentsApprovalStatus: "tpkdm:rb",
  KpiDepartmentsRequestList: "tpkdm:trm:rb",
  KpiDepartmentsRequestDetail: "tpkdm:trm:r",
  KpiDepartmentsRequestCreate: "tpkdm:trm:c",
  KpiDepartmentsRequestUpdate: "tpkdm:trm:e",
  KpiDepartmentsRequestApprove: "tpkdm:trm:ap",
  KpiDepartmentsUpdateBonus: "tpkdm:e",
  KpiDepartmentsPrintSampleList: "tpkdm:rb",
  KpiDepartmentsPrintSampleDetail: "tpkdm:r",
  KpiDepartmentsPrintSampleCreate: "tpkdm:c",
  KpiDepartmentsPrintSampleEdit: "tpkdm:e",
  KpiDepartmentsPrintSampleDelete: "tpkdm:d",

  // Payroll setting -> Benefits in kind
  PayrollSettingBenefitsInKindList: "tbikm:rb",
  PayrollSettingBenefitsInKindDetail: "tbikm:r",
  PayrollSettingBenefitsInKindCreate: "tbikm:c",
  PayrollSettingBenefitsInKindEdit: "tbikm:e",
  PayrollSettingBenefitsInKindDelete: "tbikm:d",
  PayrollSettingBenefitsInKindImport: "tbikm:im",
  PayrollSettingBenefitsInKindExport: "tbikm:rb",

  // Payroll setting -> OT rate
  PayrollSettingOTRateList: "totrm:rb",
  PayrollSettingOTRateDetail: "totrm:r",
  PayrollSettingOTRateCreate: "totrm:c",
  PayrollSettingOTRateEdit: "totrm:e",
  PayrollSettingOTRateDelete: "totrm:d",
  PayrollSettingOTRateImport: "totrm:im",
  PayrollSettingOTRateExport: "totrm:rb",

  // Payroll setting -> Approval workflow
  PayrollSettingApprovalWorkflowList: "tawm:rb",
  PayrollSettingApprovalWorkflowDetail: "tawm:r",
  PayrollSettingApprovalWorkflowCreate: "tawm:c",
  PayrollSettingApprovalWorkflowEdit: "tawm:e",
  PayrollSettingApprovalWorkflowDelete: "tawm:d",
  PayrollSettingApprovalWorkflowImport: "tawm:im",
  PayrollSettingApprovalWorkflowExport: "tawm:rb",

  // Request
  PayrollRequestList: "tpm:trm:rb",
  PayrollRequestDetail: "tpm:trm:r",
  PayrollRequestCreate: "tpm:trm:c",
  PayrollRequestEdit: "tpm:trm:e",
  PayrollRequestDelete: "tpm:trm:d",
  PayrollRequestImport: "*",
  PayrollRequestExport: "tpm:trm:rb",
  PayrollRequestApproval: "tpm:trm:ap",

  // Request Salary
  SalaryAdvanceRequestList: "tsam:trm:rb",
  SalaryAdvanceRequestDetail: "tsam:trm:r",
  SalaryAdvanceRequestCreate: "tsam:trm:c",
  SalaryAdvanceRequestEdit: "tsam:trm:e",
  SalaryAdvanceRequestDelete: "tsam:trm:d",
  SalaryAdvanceRequestImport: "*",
  SalaryAdvanceRequestExport: "tsam:trm:rb",
  SalaryAdvanceRequestApproval: "tsam:trm:ap",

  // Request Salary
  SalaryPaymentRequestList: "tspm:trm:rb",
  SalaryPaymentRequestDetail: "tspm:trm:r",
  SalaryPaymentRequestCreate: "tspm:trm:c",
  SalaryPaymentRequestEdit: "tspm:trm:e",
  SalaryPaymentRequestDelete: "tspm:trm:d",
  SalaryPaymentRequestImport: "*",
  SalaryPaymentRequestExport: "tspm:trm:rb",
  SalaryPaymentRequestApproval: "tspm:trm:ap",

  // Request Productivity Salary
  ProductivityRequestList: "tpsm:trm:rb",
  ProductivityRequestDetail: "tpsm:trm:r",
  ProductivityRequestCreate: "tpsm:trm:c",
  ProductivityRequestEdit: "tpsm:trm:e",
  ProductivityRequestDelete: "tpsm:trm:d",
  ProductivityRequestImport: "*",
  ProductivityRequestExport: "tpsm:trm:rb",
  ProductivityRequestApproval: "tpsm:trm:ap",

  // Payroll setting -> Company setting
  PayrollSettingCompanySettingList: "*",
  PayrollSettingCompanySettingCreate: "*",
  PayrollSettingCompanySettingEdit: "*",
  PayrollSettingCompanySettingDelete: "*",
  PayrollSettingCompanySettingImport: "*",
  PayrollSettingCompanySettingExport: "*",

  // Master Data -> Ethnicity
  MasterDataEthnicityList: "*",
  MasterDataEthnicityCreate: "*",
  MasterDataEthnicityEdit: "*",
  MasterDataEthnicityDelete: "*",

  // Master Data -> Currency
  MasterDataCurrencyList: "*",
  MasterDataCurrencyCreate: "*",
  MasterDataCurrencyEdit: "*",
  MasterDataCurrencyDelete: "*",

  // Master Data -> Country
  MasterDataCountryList: "*",
  MasterDataCountryListShort: "*",
  MasterDataCountryCreate: "*",
  MasterDataCountryEdit: "*",
  MasterDataCountryDelete: "*",

  // Master Data -> Province
  MasterDataProvinceList: "*",
  MasterDataProvinceListShort: "*",
  MasterDataProvinceCreate: "*",
  MasterDataProvinceEdit: "*",
  MasterDataProvinceDelete: "*",

  // Master Data -> District
  MasterDataDistrictList: "*",
  MasterDataDistrictListShort: "*",
  MasterDataDistrictCreate: "*",
  MasterDataDistrictEdit: "*",
  MasterDataDistrictDelete: "*",

  // Master Data -> Ward
  MasterDataWardList: "*",
  MasterDataWardListShort: "*",
  MasterDataWardCreate: "*",
  MasterDataWardEdit: "*",
  MasterDataWardDelete: "*",

  // Master Data -> Timezone
  MasterDataTimezoneList: "*",
  MasterDataTimezoneListShort: "*",
  MasterDataTimezoneCreate: "*",
  MasterDataTimezoneEdit: "*",
  MasterDataTimezoneDelete: "*",

  // Master Data -> Bank
  MasterDataBankList: "*",
  MasterDataBankListShort: "*",
  MasterDataBankCreate: "*",
  MasterDataBankEdit: "*",
  MasterDataBankDelete: "*",

  // Time attendance data
  TimeAttendanceDataList: "pream:rb",
  TimeAttendanceDataDetail: "pream:r",
  TimeAttendanceDataCreate: "pream:c",
  TimeAttendanceDataEdit: "pream:e",
  TimeAttendanceDataDelete: "pream:d",
  TimeAttendanceDataImport: "*",
  TimeAttendanceDataExport: "pream:rb",
  TimeAttendanceSummaryList: "*",

  TimeAttendanceImportData: "pream:cb",
  TimeAttendanceImportOTData: "pream:protm:cb",
  TimeAttendanceImportLeaveData: "pream:prelm:cb",

  // System field
  SystemFieldList: "prfm:rb",
  SystemFieldDetail: "prfm:r",
  SystemFieldCreate: "prfm:c",
  SystemFieldEdit: "prfm:e",
  SystemFieldDelete: "prfm:d",
  SystemFieldImport: "prfm:im",
  SystemFieldExport: "prfm:rb",

  // Run payroll
  RunPayrollExecute: "tpm:c",
  RunPayrollDetail: "*",
  RunPayrollValidationList: "tpm:tcrcs:rb",
  RunPayrollValidationExport: "*",
  RunPayrollValidationDetail: "*",

  // Lock data
  LockDataList: "*",
  LockDataCreate: "tpm:tlm:c",

  // Payroll
  PayrollDetail: "tpm:rb",
  PayrollExportBankTransfer: "tpm:tbk:ex",
  PayrollIssueAllPayslip: "tpm:tps:cb",
  PayrollPreviewPayslip: "tpm:tps:r",
  PayrollSendMailPayslip: "tpm:tps:sm",

  // Employee
  EmployeeList: "empl:rb",
  EmployeeDetail: "empl:r",
  EmployeeCreate: "empl:c",
  EmployeeEdit: "empl:e",
  EmployeeDelete: "*",
  EmployeeImport: "empl:im",
  EmployeeExport: "empl:rb",
  EmployeeProfileGeneralUpdate: "*",

  EmployeeDetailGeneral: "*",
  EmployeeDetailGeneralEdit: "*",

  EmployeeDetailCompensation: "tecm:r",

  EmployeeDetailSalary: "*",
  EmployeeDetailSalaryAdd: "*",
  EmployeeDetailSalaryEdit: "*",

  EmployeeDetailWorkShift: "empl:tws:r",
  EmployeeAssignWorkShift: "empl:tws:cb",
  EmployeeAssignTemplate: "empl:prtm:cb",

  EmployeeBulkUpdateCompensation: "tecm:teg:cb",

  EmployeeEarningList: "tecm:teg:rb",
  EmployeeEarningCreate: "tecm:teg:c",
  EmployeeEarningDetail: "tecm:teg:r",
  EmployeeEarningUpdate: "tecm:teg:e",
  EmployeeEarningDelete: "tecm:teg:d",
  EmployeeEarningImport: "tecm:teg:im",

  EmployeeBIKList: "*",
  EmployeeBIKCreate: "*",
  EmployeeBIKDetail: "*",
  EmployeeBIKUpdate: "*",
  EmployeeBIKDelete: "*",
  EmployeeBIKImport: "*",

  EmployeeDeductionList: "tecm:prdm:rb",
  EmployeeDeductionCreate: "tecm:prdm:c",
  EmployeeDeductionDetail: "tecm:prdm:r",
  EmployeeDeductionUpdate: "tecm:prdm:e",
  EmployeeDeductionDelete: "tecm:prdm:d",

  EmployeeAllowanceList: "tecm:pram:rb",
  EmployeeAllowanceCreate: "tecm:pram:c",
  EmployeeAllowanceDetail: "tecm:pram:r",
  EmployeeAllowanceUpdate: "tecm:pram:e",
  EmployeeAllowanceDelete: "tecm:pram:d",

  EmployeeDetailContactList: "empl:econ:rb",
  EmployeeDetailContactDetail: "empl:econ:r",
  EmployeeDetailContactAdd: "empl:econ:c",
  EmployeeDetailContactEdit: "empl:econ:e",
  EmployeeDetailContactDelete: "empl:econ:d",

  EmployeeDetailBankingList: "empl:ebac:rb",
  EmployeeDetailBankingDetail: "empl:ebac:r",
  EmployeeDetailBankingAdd: "empl:ebac:c",
  EmployeeDetailBankingEdit: "empl:ebac:e",
  EmployeeDetailBankingDelete: "empl:ebac:d",

  EmployeeDetailDependentList: "empl:edep:rb",
  EmployeeDetailDependentDetail: "empl:edep:r",
  EmployeeDetailDependentAdd: "empl:edep:c",
  EmployeeDetailDependentEdit: "empl:edep:e",
  EmployeeDetailDependentDelete: "empl:edep:d",

  EmployeeDetailIDCardList: "empl:eidc:rb",
  EmployeeDetailIDCardDetail: "empl:eidc:r",
  EmployeeDetailIDCardAdd: "empl:eidc:c",
  EmployeeDetailIDCardEdit: "empl:eidc:e",
  EmployeeDetailIDCardDelete: "empl:eidc:d",

  EmployeeDetailInsuranceList: "empl:eiif:rb",
  EmployeeDetailInsuranceDetail: "empl:eiif:r",
  EmployeeDetailInsuranceAdd: "empl:eiif:c",
  EmployeeDetailInsuranceEdit: "empl:eiif:e",
  EmployeeDetailInsuranceDelete: "*",

  EmployeeDetailEmergencyList: "empl:eeco:rb",
  EmployeeDetailEmergencyDetail: "empl:eeco:r",
  EmployeeDetailEmergencyAdd: "empl:eeco:c",
  EmployeeDetailEmergencyEdit: "empl:eeco:e",
  EmployeeDetailEmergencyDelete: "empl:eeco:d",

  EmployeeDetailEducationList: "empl:eedu:rb",
  EmployeeDetailEducationDetail: "empl:eedu:r",
  EmployeeDetailEducationAdd: "empl:eedu:c",
  EmployeeDetailEducationEdit: "empl:eedu:e",
  EmployeeDetailEducationDelete: "empl:eedu:d",

  EmployeeDetailRewardDisciplineList: "empl:rb",
  EmployeeDetailRewardDisciplineDetail: "empl:r",
  EmployeeDetailRewardDisciplineAdd: "empl:c",
  EmployeeDetailRewardDisciplineEdit: "empl:e",
  EmployeeDetailRewardDisciplineDelete: "empl:d",

  EmployeeDetailWorkAccidentList: "empl:rb",
  EmployeeDetailWorkAccidentDetail: "empl:r",
  EmployeeDetailWorkAccidentAdd: "empl:c",
  EmployeeDetailWorkAccidentEdit: "empl:e",
  EmployeeDetailWorkAccidentDelete: "empl:d",

  EmployeeDetailDocumentList: "empl:edoc:rb",
  EmployeeDetailDocumentDetail: "empl:edoc:r",
  EmployeeDetailDocumentAdd: "empl:edoc:c",
  EmployeeDetailDocumentEdit: "empl:edoc:e",
  EmployeeDetailDocumentDelete: "*",

  EmployeeDetailDocuments: "*",

  EmployeeDetailWorkHistory: "empl:eewe:rb",

  // Employee detail -> General info

  // Company
  CompanyDetail: "comp:r",
  CompanyUpdate: "comp:e",

  CompanySettingList: "comp:tcsm:rb",
  CompanySettingEdit: "comp:tcsm:e",

  // Company -> Work level
  PayrollSettingWorkLevelList: "comp:wlvl:rb",
  PayrollSettingWorkLevelCreate: "comp:wlvl:r",
  PayrollSettingWorkLevelDetail: "comp:wlvl:c",
  PayrollSettingWorkLevelEdit: "comp:wlvl:e",
  PayrollSettingWorkLevelDelete: "comp:wlvl:d",
  PayrollSettingWorkLevelImport: "comp:wlvl:im",
  PayrollSettingWorkLevelExport: "comp:wlvl:rb",

  // Company -> Contract type
  CompanyContractTypeList: "comp:cont:rb",
  CompanyContractTypeCreate: "comp:cont:c",
  CompanyContractTypeDetail: "comp:cont:r",
  CompanyContractTypeEdit: "comp:cont:e",
  CompanyContractTypeDelete: "comp:cont:d",
  CompanyContractTypeImport: "comp:cont:im",
  CompanyContractTypeExport: "comp:cont:rb",

  // Company -> Department
  CompanyDepartmentList: "comp:dept:rb",
  CompanyDepartmentListShort: "comp:dept:rbs",
  CompanyDepartmentCreate: "comp:dept:c",
  CompanyDepartmentEdit: "comp:dept:e",
  CompanyDepartmentDelete: "*",
  CompanyDepartmentImport: "*",
  CompanyDepartmentExport: "comp:dept:rb",

  // Company -> Branch
  CompanyBranchList: "comp:bran:rb",
  CompanyBranchCreate: "comp:bran:c",
  CompanyBranchEdit: "comp:bran:e",
  CompanyBranchDelete: "comp:bran:d",
  CompanyBranchImport: "comp:bran:im",
  CompanyBranchExport: "comp:bran:rb",

  // Company -> Title
  CompanyTitleList: "comp:titl:rb",
  CompanyTitleCreate: "comp:titl:c",
  CompanyTitleEdit: "comp:titl:e",
  CompanyTitleDelete: "comp:titl:d",
  CompanyTitleImport: "comp:titl:im",
  CompanyTitleExport: "comp:titl:rb",

  // Company -> Standard Working Day
  CompanyStandardWorkingDayList: "comp:tcsm:rb",
  CompanyStandardWorkingDayDetail: "comp:tcsm:r",
  CompanyStandardWorkingDayCreate: "comp:tcsm:c",
  CompanyStandardWorkingDayEdit: "comp:tcsm:e",
  CompanyStandardWorkingDayDelete: "comp:tcsm:d",
  CompanyStandardWorkingDayImport: "comp:tcsm:im",
  CompanyStandardWorkingDayExport: "comp:tcsm:rb",

  // Company -> 13th setting
  Company13thSettingList: "comp:tctsm:rb",
  Company13thSettingDetail: "comp:tctsm:r",
  Company13thSettingCreate: "comp:tctsm:c",
  Company13thSettingEdit: "comp:tctsm:e",
  Company13thSettingDelete: "comp:tctsm:d",
  Company13thSettingImport: "comp:tctsm:im",
  Company13thSettingExport: "comp:tctsm:rb",

  // Company -> Org chart
  CompanyOrgChartList: "orgc:r",
  CompanyOrgChartShowEmployees: "orgc:empl:rb",
  CompanyOrgChartCreate: "orgc:c",
  CompanyOrgChartEdit: "orgc:e",
  CompanyOrgChartDelete: "*",
  CompanyOrgChartImport: "*",
  CompanyOrgChartExport: "orgc:rb",

  // Company -> KPI Bonus Config
  CompanyKPIBonusConfigList: "comp:kbc:rb",
  CompanyKPIBonusConfigCreate: "comp:kbc:c",
  CompanyKPIBonusConfigEdit: "comp:kbc:e",
  CompanyKPIBonusConfigDelete: "comp:kbc:d",
  CompanyKPIBonusConfigImport: "comp:kbc:im",
  CompanyKPIBonusConfigExport: "comp:kbc:rb",

  // Company -> Role
  CompanyRoleList: "trol:rb",
  CompanyRoleDetail: "trol:r",
  CompanyRoleCreate: "trol:c",
  CompanyRoleEdit: "trol:e",
  CompanyRoleDelete: "trol:d",
  CompanyRoleImport: "trol:im",
  CompanyRoleExport: "trol:rb",

  // Company -> Group employee
  CompanyGroupEmployeeList: "tgem:rb",
  CompanyGroupEmployeeDetail: "tgem:r",
  CompanyGroupEmployeeCreate: "tgem:c",
  CompanyGroupEmployeeEdit: "tgem:e",
  CompanyGroupEmployeeDelete: "tgem:d",
  CompanyGroupEmployeeImport: "tgem:im",
  CompanyGroupEmployeeExport: "tgem:rb",

  CompanyGroupEmployeeDetailEmployeeList: "tgem:empl:rb",
  CompanyGroupEmployeeDetailEmployeeCreate: "tgem:empl:cb",
  CompanyGroupEmployeeDetailEmployeeRemove: "tgem:empl:db",

  CompanyGroupEmployeeDetailRoleList: "tgem:trol:rb",
  CompanyGroupEmployeeDetailRoleCreate: "tgem:trol:cb",
  CompanyGroupEmployeeDetailRoleRemove: "tgem:trol:db",

  // Company -> Feature
  CompanyFeatureList: "comp:feat:rb",
  CompanyFeatureDetail: "comp:feat:r",
  CompanyFeatureCreate: "comp:feat:c",
  CompanyFeatureEdit: "comp:feat:e",
  CompanyFeatureDelete: "comp:feat:d",
  CompanyFeatureImport: "comp:feat:im",
  CompanyFeatureExport: "comp:feat:rb",

  // Report -> Payroll Summary
  ReportPayrollSummaryList: "trptm:tsmr:r",
  ReportPayrollSummaryExport: "trptm:tsmr:r",

  // Report -> Payroll reconcile
  ReportPayrollReconcileList: "trptm:tpm:r",
  ReportPayrollReconcileExport: "trptm:tpm:r",

  // Report -> SHUI Contribution
  ReportSHUIContributionList: "trptm:prdm:r",
  ReportSHUIContributionExport: "trptm:prdm:r",

  // Report -> OT Report
  ReportOTReportList: "trptm:protm:r",
  ReportOTReportExport: "trptm:protm:r",

  // Report -> Attendance Report
  ReportAttendanceReportList: "trptm:pream:r",
  ReportAttendanceReportExport: "trptm:pream:r",

  // Report -> Leave Report
  ReportLeaveReportList: "trptm:prelm:r",
  ReportLeaveReportExport: "trptm:prelm:r",

  // Report -> PIT Summary
  ReportPITSummaryList: "trptm:tpit:r",
  ReportPITSummaryExport: "trptm:tpit:r",

  // Report -> One Stream
  ReportOneStreamList: "trptm:tpm:r",
  ReportOneStreamExport: "trptm:tpm:r",

  // Report -> Employee Profile
  ReportEmployeeProfileList: "trptm:empl:r",
  ReportEmployeeProfileExport: "trptm:empl:r",

  // Report -> Diligence
  ReportDiligenceList: "trptm:tpm:r",
  ReportDiligenceExport: "trptm:tpm:r",

  // Report -> Labor Management Book
  ReportLaborManagementBookList: "trptm:empl:r",
  ReportLaborManagementBookExport: "trptm:empl:r",

  // Adjustment
  AdjustmentCreate: "tajm:cb",
  AdjustmentList: "tajm:rb",

  // Salary Advance
  SalaryAdvanceCreate: "tsam:cb",
  SalaryAdvanceList: "tsam:rb",
  SalaryAdvanceDetail: "tsam:r",
  SalaryAdvanceDetailExportBank: "tsam:tbk:ex",
  SalaryAdvanceEditDetail: "tsam:eb",
  SalaryAdvanceEdit: "tsam:eb",
  SalaryAdvanceDelete: "tsam:d",
  SalaryAdvanceImport: "tsam:im",
  SalaryAdvanceExport: "tsam:rb",

  // Salary Advance
  SalaryPaymentCreate: "tspm:cb",
  SalaryPaymentList: "tspm:rb",
  SalaryPaymentDetail: "tspm:r",
  SalaryPaymentDetailExportBank: "tspm:tbk:ex",
  SalaryPaymentEditDetail: "tspm:eb",
  SalaryPaymentEdit: "tspm:eb",
  SalaryPaymentDelete: "tspm:d",
  SalaryPaymentImport: "tspm:im",
  SalaryPaymentExport: "tspm:rb",

  // Audit log
  AuditLogList: "alm:rb",
  AuditLogDetail: "alm:r",
  AuditLogExport: "alm:rb",
  AuditLogDelete: "alm:d",

  // Payroll Cycle
  PayrollCycleList: "tpcm:rb",
  PayrollCycleDetail: "tpcm:r",
  PayrollCycleCreate: "tpcm:c",
  PayrollCycleEdit: "tpcm:e",
  PayrollCycleDelete: "tpcm:d",
  PayrollCycleImport: "tpcm:im",
  PayrollCycleActive: "tpcm:ac",
  PayrollCycleInactive: "tpcm:in",

  // Employee template
  EmployeeTemplateInactive: "prtm:tetf:in",
  EmployeeTemplateActive: "prtm:tetf:ac",
  EmployeeTemplateDelete: "prtm:tetf:d",
  EmployeeTemplateCreate: "prtm:tetf:cb",
  EmployeeTemplateList: "prtm:tetf:rb",

  // PITs
  PITList: "tpitm:rb",
  PITCreate: "tpitm:cb",
  PITUpdate: "tpitm:e",
  PITDelete: "tpitm:d",

  // Product Activity
  PAMachineList: "tmm:rb",
  PAMachineDetail: "tmm:r",
  PAMachineCreate: "tmm:c",
  PAMachineEdit: "tmm:e",
  PAMachineDelete: "tmm:d",
  PAMachineImport: "tmm:im",
  PAMachineExport: "tmm:rb",

  PAProductList: "tpdm:rb",
  PAProductDetail: "tpdm:r",
  PAProductCreate: "tpdm:c",
  PAProductEdit: "tpdm:e",
  PAProductDelete: "tpdm:d",
  PAProductImport: "tpdm:im",
  PAProductExport: "tpdm:rb",

  PAMachineGroupList: "tgmm:rb",
  PAMachineGroupDetail: "tgmm:r",
  PAMachineGroupCreate: "tgmm:c",
  PAMachineGroupEdit: "tgmm:e",
  PAMachineGroupDelete: "tgmm:d",
  PAMachineGroupImport: "tgmm:im",
  PAMachineGroupExport: "tgmm:rb",

  PAReasonStopList: "trsmm:rb",
  PAReasonStopDetail: "trsmm:r",
  PAReasonStopCreate: "trsmm:c",
  PAReasonStopEdit: "trsmm:e",
  PAReasonStopDelete: "trsmm:d",
  PAReasonStopImport: "trsmm:im",
  PAReasonStopExport: "trsmm:rb",

  PAStandardQuantityList: "tsqm:rb",
  PAStandardQuantityDetail: "tsqm:r",
  PAStandardQuantityCreate: "tsqm:c",
  PAStandardQuantityEdit: "tsqm:e",
  PAStandardQuantityDelete: "tsqm:d",
  PAStandardQuantityImport: "tsqm:im",
  PAStandardQuantityExport: "tsqm:rb",

  PAProductionLogList: "tpod:tppl:rb",
  PAProductionLogDetail: "tpod:tppl:r",
  PAProductionLogCreate: "tpod:tppl:cb",
  PAProductionLogEdit: "tpod:tppl:eb",
  PAProductionLogDelete: "tpod:tppl:d",
  PAProductionLogImport: "tpod:tppl:cb",
  PAProductionLogExport: "*",
  PAProductionLogSync: "tpod:tppl:cb",

  PAMachineDowntimeList: "tpod:tpotmd:rb",
  PAMachineDowntimeDetail: "tpod:tpotmd:r",
  PAMachineDowntimeCreate: "tpod:tpotmd:cb",
  PAMachineDowntimeEdit: "tpod:tpotmd:eb",
  PAMachineDowntimeDelete: "tpod:tpotmd:d",
  PAMachineDowntimeImport: "tpod:tpotmd:cb",
  PAMachineDowntimeExport: "*",
  PAMachineDowntimeSync: "tpod:tpotmd:cb",

  PAOTWithoutMachineOperationsList: "tpod:tpowmo:rb",
  PAOTWithoutMachineOperationsDetail: "tpod:tpowmo:r",
  PAOTWithoutMachineOperationsCreate: "tpod:tpowmo:cb",
  PAOTWithoutMachineOperationsEdit: "tpod:tpowmo:eb",
  PAOTWithoutMachineOperationsDelete: "tpod:tpowmo:d",
  PAOTWithoutMachineOperationsImport: "tpod:tpowmo:cb",
  PAOTWithoutMachineOperationsExport: "*",
  PAOTWithoutMachineOperationsSync: "tpod:tpowmo:cb",

  // Payroll setting -> Payroll template
  PATemplateList: "tptm:rb",
  PATemplateDetail: "tptm:r",
  PATemplateCreate: "tptm:c",
  PATemplateEdit: "tptm:e",
  PATemplateDelete: "tptm:d",
  PATemplateImport: "tptm:im",
  PATemplateExport: "*",
  PATemplateCreateField: "tptm:tpsfm:c",
  PATemplateCreateGroupField: "tptm:tptgfm:c",
  PATemplateUpdateBulkField: "tptm:tpsfm:eb",
  PATemplateUpdateBulkGroupField: "tptm:tptgfm:eb",
  PATemplatePrintTemplateCreate: "tptm:c",
  PATemplatePrintTemplateEdit: "tptm:e",
  PATemplatePrintTemplateDeteil: "tptm:r",
  PATemplatePrintTemplateDelete: "tptm:d",
  PATemplatePrintTemplateList: "tptm:rb",

  PARunSalary: "tpsm:c",
  PASalary: "tpsm:rb",
  PASalarySummary: "tpsm:rb",
  PARun13thMonthSalary: "tpthirteenthm:c",
  PA13thMonthSalary: "tpthirteenthm:rb",
  PA13thMonthSalaryUpdate: "tpthirteenthm:e",
  PA13thMonthSalaryPrintSampleList: "tpthirteenthm:rb",
  PA13thMonthSalaryPrintSampleDetail: "tpthirteenthm:r",
  PA13thMonthSalaryPrintSampleCreate: "tpthirteenthm:c",
  PA13thMonthSalaryPrintSampleEdit: "tpthirteenthm:e",
  PA13thMonthSalaryPrintSampleDelete: "tpthirteenthm:d",
  PAIssuePayslip: "tpm:tps:sm",

  PAEmployeeTemplateList: "tptm:teptm:rb",
  PAEmployeeTemplateCreate: "tptm:teptm:cb",
  PAEmployeeTemplateDelete: "tptm:teptm:d",
} as const;
